import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'

export function use(
  client: OvpClient,
  privacy: API['privacy'],
  _api: API
): void {
  // POST /api/web/feedback/privacy-data
  privacy.setPrivacyOptOutFx.use(async (params) => {
    payload(await client.post.api.web.feedback.privacyData({ body: params }))
  })

  // POST /api/web/feedback/sensitive-data-request
  privacy.setPrivacySensitiveDataFx.use(async (params) => {
    payload(
      await client.post.api.web.feedback.sensitiveDataRequest({ body: params })
    )
  })
}
